<template>
    <div>
        <nav class="breadcrumb bg-white push">
            <a class="breadcrumb-item" href="javascript:void(0)">Dashboard</a>
            <span class="breadcrumb-item active">Beneficiaries</span>
        </nav>

        <div class="block-content">
            <div class="row">
                <button
                    type="button"
                    class="btn btn-info text-white mr-5 mb-5"
                    @click.prevent="newModal"
                >
                    <i class="fa fa-plus mr-5"></i> Create Contact
                </button>
            </div>
            <hr />
            <div class="row">
                <div class="col-sm-12 table-responsive">
                    <table
                        class="table table-bordered table-striped table-vcenter js-dataTable-simple dataTable no-footer"
                        id="DataTables_Table_0"
                        role="grid"
                        aria-describedby="DataTables_Table_0_info"
                    >
                        <thead>
                            <tr role="row">
                                <th class="text-capitalize">Name</th>
                                <th class="text-capitalize">Account</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                role="row"
                                class="odd"
                                v-for="(contact, index) in banks"
                                :key="contact.id"
                            >
                                <td>
                                    {{ contact.name }}
                                </td>
                                <td>
                                    {{ contact.account }}
                                </td>
                                <td>
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-danger"
                                        data-toggle="tooltip"
                                        title="Delete"
                                        @click.prevent="deleteContact(contact.id)"
                                    >
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div
            class="modal fade"
            id="modal-fadein"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modal-fadein"
            style="display: none;"
            aria-hidden="true"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="card-title">Add Contact</h3>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <!-- Beginning of the form -->
                    <form @submit.prevent="createContact">
                        <div class="modal-body">
                            <div class="card">
                                <div class="card-body">
                                    <div class="form-group">
                                        <label for="name" class="text-muted"
                                            >Name</label
                                        >
                                        <input
                                            v-model="form.name"
                                            type="text"
                                            class="form-control"
                                            id="name"
                                            required
                                        />
                                    </div>
                                    <div class="form-group">
                                        <label for="name" class="text-muted"
                                            >Account Number</label
                                        >
                                        <input
                                            v-model="form.account"
                                            type="text"
                                            class="form-control"
                                            id="name"
                                            required
                                        />
                                    </div>
                                    <button
                                        :disabled="processing"
                                        type="submit"
                                        class="btn btn-lg btn-outline-success mb-2"
                                    >
                                        {{
                                            processing ? "processing" : "Create"
                                        }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "../../../repository/RepositoryFactory";

const UsersRepository = RepositoryFactory.get("users");
export default {
    data() {
        return {
            banks: [],
            processing: false,
            form: new Form({
                id: "",
                name: "",
                account: "",
            })
        };
    },
    methods: {
        newSetUp() {
            this.editmode = false;
            this.form.reset();
            $("#modal-fadein2").modal("show");
        },

        newModal() {
            this.editmode = false;
            this.form.reset();
            $("#modal-fadein").modal("show");
        },
        editModal(contact) {
            this.editmode = true;
            this.form.reset();
            $("#modal-fadein").modal("show");
            this.form.fill(contact);
        },
        async createContact() {
            try {
                await UsersRepository.createContact({
                    name: this.form.name,
                    account: this.form.account,
                });
                toast.fire({
                    type: "success",
                    title: "Contact created successfully"
                });
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } catch (error) {
                toast.fire({
                    type: "warning",
                    title: "Failed to create contact"
                });
            }
        },
        async deleteContact($id) {
            try {
                await UsersRepository.deleteContact($id);
                toast.fire({
                    type: "success",
                    title: "Contact deleted successfully"
                });
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } catch (error) {
                toast.fire({
                    type: "warning",
                    title: "Failed to delete contact"
                });
            }
        },
      
        loadContacts() {
            UsersRepository.viewContacts().then(response => {
                this.banks = response.data;
            });
        }
    },
    created() {
        this.loadContacts();
    }
};
</script>
